// NGRX
import { createFeatureSelector } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter, Update } from '@ngrx/entity';
// Actions
import { PatientHeightActions, PatientHeightActionTypes } from '../_actions/patient-height.actions';
// Models
import { PatientHeightModel } from '../_models/patient-height.model';
import { QueryParamsModel } from '../../_base/crud';

export interface PatientHeightsState extends EntityState<PatientHeightModel> {
  listLoading: boolean;
  actionsloading: boolean;
  totalCount: number;
  lastCreatedPatientHeightId: number;
  lastQuery: QueryParamsModel;
  showInitWaitingMessage: boolean;
  error: any | null;
}

export const adapter: EntityAdapter<PatientHeightModel> = createEntityAdapter<PatientHeightModel>();

export const initialPatientHeightsState: PatientHeightsState = adapter.getInitialState({
  patientHeightForEdit: null,
  listLoading: false,
  actionsloading: false,
  totalCount: 0,
  lastCreatedPatientHeightId: undefined,
  lastQuery: new QueryParamsModel({}),
  showInitWaitingMessage: true,
  error: null,
});

export function patientHeightsReducer(
  state = initialPatientHeightsState,
  action: PatientHeightActions,
): PatientHeightsState {
  switch (action.type) {
    case PatientHeightActionTypes.PatientHeightsPageToggleLoading: {
      return {
        ...state,
        listLoading: action.payload.isLoading,
        lastCreatedPatientHeightId: undefined,
      };
    }
    case PatientHeightActionTypes.PatientHeightActionToggleLoading: {
      return {
        ...state,
        actionsloading: action.payload.isLoading,
      };
    }
    case PatientHeightActionTypes.PatientHeightOnServerCreated:
      return {
        ...state,
      };
    case PatientHeightActionTypes.PatientHeightCreated:
      return adapter.addOne(action.payload.patientHeight, {
        ...state,
        lastCreatedPatientHeightId: action.payload.patientHeight.id,
      });
    case PatientHeightActionTypes.PatientHeightUpdated:
      return adapter.updateOne(action.payload.partialPatientHeight, state);
    case PatientHeightActionTypes.PatientHeightStatusUpdated: {
      // tslint:disable-next-line
      const _partialPatientHeight: Update<PatientHeightModel> = {
        id: action.payload.patientHeight.id,
        changes: {
          is_active: action.payload.is_active,
        },
      };
      // tslint:disable-next-line:prefer-const
      // tslint:disable-next-line
      return adapter.updateOne(_partialPatientHeight, state);
    }
    case PatientHeightActionTypes.PatientHeightsStatusUpdated: {
      // tslint:disable-next-line
      const _partialPatientHeights: Update<PatientHeightModel>[] = [];
      // tslint:disable-next-line:prefer-const
      // tslint:disable-next-line
      for (let i = 0; i < action.payload.patientHeights.length; i++) {
        _partialPatientHeights.push({
          id: action.payload.patientHeights[i].id,
          changes: {
            is_active: action.payload.is_active,
          },
        });
      }
      return adapter.updateMany(_partialPatientHeights, state);
    }
    case PatientHeightActionTypes.OnePatientHeightDeleted:
      return adapter.removeOne(action.payload.id, state);
    case PatientHeightActionTypes.ManyPatientHeightsDeleted:
      return adapter.removeMany(action.payload.ids, state);
    case PatientHeightActionTypes.PatientHeightsPageCancelled: {
      return {
        ...state,
        listLoading: false,
        lastQuery: new QueryParamsModel({}),
      };
    }
    case PatientHeightActionTypes.PatientHeightsPageLoaded: {
      return adapter.addMany(action.payload.patientHeights, {
        ...initialPatientHeightsState,
        totalCount: action.payload.totalCount,
        listLoading: false,
        lastQuery: action.payload.page,
        showInitWaitingMessage: false,
      });
    }
    case PatientHeightActionTypes.ThrowPatientHeightError: {
      return {
        ...state,
        error: action.payload.error,
        actionsloading: false,
        listLoading: false,
      };
    }
    case PatientHeightActionTypes.ClearPatientHeightErrors: {
      return {
        ...state,
        error: null,
      };
    }
    default:
      return state;
  }
}

export const getPatientHeightState = createFeatureSelector<PatientHeightModel>('patientHeights');

export const { selectAll, selectEntities, selectIds, selectTotal } = adapter.getSelectors();
